export const generateSortingLogicMidFeedAds = (
  midFeedAds = [],
  facetTitle,
  locationTitle,
  parentLocationTitle
) => {
  const nonSpecializationTaxonomies = [
    'what_we_treat',
    'who_we_treat',
    'treatment_method',
    'treatment_services',
    'treatment_therapies',
    'setting',
    'price',
    'accepted_insurance',
    'amenities'
  ]

  const nonSpecializedMidFeedAdsTreatingFacet = midFeedAds.filter((ad) =>
    nonSpecializationTaxonomies.some((taxonomy) => {
      return ad[taxonomy]?.includes(facetTitle)
    })
  )

  let facetedMidFeedAdsForLocation = nonSpecializedMidFeedAdsTreatingFacet

  if (facetedMidFeedAdsForLocation.length === 0) {
    facetedMidFeedAdsForLocation = nonSpecializedMidFeedAdsTreatingFacet.filter(
      (ad) => {
        return ad.locationMiddleFeed?.some((location) =>
          location.title.includes(parentLocationTitle)
        )
      }
    )
  }

  return facetedMidFeedAdsForLocation.filter((ad) => ad.budget_pacing > 0)
}
